import { fetchProducts } from './js/fetchProducts';

document.addEventListener('DOMContentLoaded', () => {
  fetchProducts();
});
